import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Results() {
  const results = ['Más confianza al enfrentarse a un texto', 'Menos frustración en los momentos de lectura', 'Lectura más fluida y natural', 'Momentos de práctica sin peleas'];
  return <section className="w-full bg-cream py-20 md:py-28 px-4" data-id="element-135">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-136">
        {/* Checklist Side */}
        <div className="space-y-10" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-bold text-dark leading-tight" data-id="element-138">
            En pocas semanas vas a notar cambios reales.
          </h2>

          <ul className="space-y-6" data-id="element-139">
            {results.map((item, index) => <li key={index} className="flex items-start space-x-4 p-4 bg-white rounded-xl shadow-sm border border-cream-dark" data-id="element-140">
                <CheckCircle2 className="w-6 h-6 text-olive shrink-0 mt-0.5" data-id="element-141" />
                <span className="text-lg text-dark font-medium" data-id="element-142">{item}</span>
              </li>)}
          </ul>

          <div className="pt-4" data-id="element-143">
            <button onClick={() => window.open('https://www.gaiadigitalpro.com/checkouts/cn/hWN91detKUA3JZvySec9CenJ/es-ar?_r=AQABrOvx_mroREqaZDGTff6UkVA7_iuSpYNGcQFEgzuoo40&preview_theme_id=163059597347', '_blank')} className="hover:bg-terracotta-light text-white font-serif text-lg px-10 py-4 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 w-full md:w-auto bg-[#6FC628]" data-id="element-144">
              Sí, quiero empezar hoy
            </button>
          </div>
        </div>

        {/* Image Side */}
        <div className="relative" data-id="element-145">
          <div className="absolute top-4 -left-4 w-full h-full border-2 border-gold/30 rounded-2xl -z-10" data-id="element-146"></div>
          <img src="https://cdn.magicpatterns.com/uploads/gbPUkjYFiRM7R8c34SSBDE/nene_4.jpg" alt="Niño leyendo concentrado" className="w-full h-auto rounded-2xl shadow-lg object-cover" data-id="element-147" />
        </div>
      </div>
    </section>;
}